export enum FILTER_TYPE {
    MATCH,
    EQUAL_LESS_GREATER
}